/*========================================================================
* $Id: list.js 124298 2018-01-15 14:43:10Z erhard.einsiedler $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(["underscore"], function (_) {

  function mergeProperty(lhs, rhs, nestedProperties) {
    if (!lhs) {
      lhs = {formats:[]};
    }

    // The displayedProperties in ResultsView (results.js) might not contain formats or format property.
    lhs.formats = lhs.formats ? lhs.formats : [];
    if (lhs.format !== undefined) {
      lhs.formats = _.union(lhs.formats, lhs.format);
      delete lhs.format;
    }

    if (!rhs) return lhs;

    var formats = rhs.formats || [rhs.format];
    lhs.formats = _.union(lhs.formats, formats);

    if (!lhs.properties && rhs.properties) {
      lhs.properties = {}; // rhs.properties;
    }
    if (lhs.properties && rhs.properties) {
      _.each(_.union(_.keys(lhs.properties), _.keys(rhs.properties)), function (key) {
          if (!_.contains(nestedProperties, key)) {
            if (lhs.properties[key]) delete lhs.properties[key].properties;
            if (rhs.properties[key]) delete rhs.properties[key].properties;
          }
          lhs.properties[key] = mergeProperty(lhs.properties[key], rhs.properties[key]);
      });
    }
    return lhs;
  }

  return {
    mergeProperty: mergeProperty
  }
});
